export class CreateUserModel {
  public email: string;
  public firstname: string;
  public lastname: string;
  public language: string;
  public site: string;
  public organizationId: string;
  public targetOrganizationId: string;
  public mobile: string;
  public smsVerification: boolean;
  public targetMembershipType: number;

  constructor(data: any) {
    if (data) {
      this.email = data.email;
      this.firstname = data.firstname;
      this.lastname = data.lastname;
      this.language = data.language;
      this.site = data.site;
      this.organizationId = data.organizationId;
      this.targetOrganizationId = data.targetOrganizationId;
      this.mobile = data.mobile;
      this.smsVerification = data.smsVerification;
      this.targetMembershipType = data.targetMembershipType;
    }
  }
}
